import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { CONFIG, PILES, waLink } from "../../data/content";
import { useLang } from "../../context/i18n";
import { Reveal } from "./Motion";
import { track } from "./Chrome";

export const PilesFistula = () => {
  const { t } = useLang();
  return (
    <section id="piles-fistula" className="bg-[var(--bg-soft)] py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 lg:grid-cols-2 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl ring-1 ring-slate-200 shadow-lg">
            <img src={CONFIG.images.pilesFistula} alt="Illustration of a comfortable modern daycare setup for painless piles and fistula surgery" loading="lazy"
                 className="w-full object-cover" />
          </div>
          <span className="mt-3 inline-block rounded-full bg-[var(--green)]/10 px-4 py-1.5 text-xs font-bold text-[var(--green)]">Daycare procedure • Short stay</span>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="font-head text-sm font-bold uppercase tracking-widest text-[var(--red)]">Specialised Care</p>
          <h2 className="mt-3 font-head text-3xl font-extrabold tracking-tight text-[var(--navy)] sm:text-4xl lg:text-5xl">{t(PILES.title)}</h2>
          <p className="mt-5 text-base leading-relaxed text-[var(--slate)] md:text-lg">{t(PILES.sub)}</p>

          <ul className="mt-6 space-y-3">
            {PILES.points.map((p, i) => (
              <li key={i} data-testid={`piles-point-${i}`} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--green)] text-white"><Check size={14} /></span>
                <span className="text-sm font-semibold text-[var(--navy)]">{t(p)}</span>
              </li>
            ))}
          </ul>

          <p className="mt-5 text-xs leading-relaxed text-slate-400">{t(PILES.note)}</p>

          <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => track("piles_consult")} data-testid="piles-consult-btn"
             className="mt-6 inline-flex items-center gap-2 rounded-full bg-[var(--navy)] px-6 py-3.5 text-sm font-bold text-white transition-all hover:scale-[1.03] hover:bg-[var(--navy-light)]">
            {t(PILES.cta)} <ArrowRight size={18} />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
